module.exports = __webpack_public_path__ + "img/logo.4c1777f7.svg";